// extracted by mini-css-extract-plugin
module.exports = {"oox3lfc":"oox3lfc","f1m9rsgq":"f1m9rsgq","g1mu1r5v":"g1mu1r5v","g16o8xhw":"g16o8xhw"};